import React, { useContext, useEffect, useState } from 'react'
import { ListingFilter } from '../components/ListingFilter'
import classNames from 'classnames'
import { applyHandler } from '../utils/functions'
import { useRouter } from 'next/router'
import ImageWithBasePath from './ImageWithBasePath'
import { fetchOptions } from '../utils/functions'
import { SharedContext } from '../context/SharedContext'
import { SeekerContext } from '../context/SeekerContext'

export const FloatingFilters = ({ selectedFilter, setSelectedFilter, sortedFiltersData }) => {
  const { language } = useContext(SharedContext);

  const { body, setBody, filterTitleIds, setCurrentPage } = useContext(SeekerContext);

  const [isFilterOpen, setFilterOpen] = useState(false)
  const [optionsFloating, setOptionsFloating] = useState({})
  const router = useRouter()

  const filterCloseHandler = () => {
    setFilterOpen(false)
    setSelectedFilter('')
  }

  useEffect(() => {
    applyHandler(body?.selectedOptions, false, filterTitleIds, setBody, router)

  }, [])

  useEffect(() => {
    fetchOptions({
      selectedTitleId: process.env.NEXT_PUBLIC_SALARY_TITLE_ID,
      setOptions: setOptionsFloating,
      options: optionsFloating,
      setLoader: () => {},
      language
    })
  }, [])

  const isOptionPresent = (id) => {
    let count = 0;
    body?.selectedOptions?.[id]?.forEach((item) => {
      const optionValue = optionsFloating?.[id]?.find((i) => i.id == item.id)
      if (optionValue) count ++
    })
    return count
  }

  return (
    <>
      <ListingFilter
        selectedId={selectedFilter}
        isOpen={isFilterOpen}
        handleModalClose={filterCloseHandler}
        filterTitles={sortedFiltersData}
        applyHandler={(body, redirect) =>
          applyHandler(body, redirect, filterTitleIds, setBody, router, setCurrentPage)
        }
        initialSelectedOptions={body?.selectedOptions}
      />
      <div
        className={classNames(' w-[100%] space-y-[12px] bg-[#F8F8F8]')}
        id="floating_filters_container"
      >
        {/* Here Scroll is a separate styling in global.css */}
        <div className="scroll flex" id="floating_filters_div">
          {sortedFiltersData?.map((item, index) => (
            <div
              className={classNames(
                'flex items-center rounded-[4px] border-[1px] border-solid bg-[white] p-[8px]',
                body?.apiBody?.[item?.id]?.length > 0
                  ? 'border-[#FFBB00] font-bold text-[#CC9600]'
                  : 'border-[#E5E5E6]',
                index > 0 && 'ml-[5px]'
              )}
              onClick={() => {
                setSelectedFilter(item.id)
                setFilterOpen(true)
              }}
              key={index}
              id={index + '_floating_filters'}
            >
              <div
                className="mr-[14px] select-none whitespace-nowrap font-noto-sans text-sm"
                id="ff_filter_name"
              >
                {item.english_name}
                {body?.apiBody?.[item?.id]?.length > 0 && (
                  <span className="pl-[4px]">{`(${
                    item?.id == process.env.NEXT_PUBLIC_SALARY_TITLE_ID ? isOptionPresent(item.id) :
                    body?.selectedOptions?.[item?.id]?.length
                  })`}</span>
                )}
              </div>
              <div id="ff_downArrowIcon">
                <ImageWithBasePath
                  src="downArrowIcon"
                  height={5}
                  width={9}
                  alt="down arrow symbol"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
